import { ReadWriteControlsConfig } from 'libs/hooks';

export const shouldRequire = (
  key: string,
  config: ReadWriteControlsConfig,
  defaultValue = true,
): boolean => {
  // Default required unless explicitly optional in a WOT config.
  return config[key]?.required ?? defaultValue;
};

export const isReadOnly = (
  key: string,
  config: ReadWriteControlsConfig,
): boolean => !!config[key]?.readOnly;
